import * as tslib_1 from "tslib";
import { Select, TextField } from '@nextiva/next-ui';
import cx from 'classnames';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import DatePicker from '../../../../DatePicker';
import "./DateRow.css";
var DATE_FORMAT = 'MM/DD/YYYY';
var MIN_DATE = '10/11/2015';
var MAX_HOURS = 12;
var MAX_MINUTES = 59;

var DateRow =
/** @class */
function (_super) {
  tslib_1.__extends(DateRow, _super);

  function DateRow(props) {
    var _this = _super.call(this, props) || this;

    _this.getInputValues = function (date) {
      return {
        hours: date.format('hh'),
        minutes: date.format('mm'),
        meridiem: date.format('a')
      };
    };

    _this.checkDate = function (date) {
      //todo check if it could be event here
      var timezone = _this.props.timezone;

      if (date === undefined) {
        return false;
      } else if (date === null) {
        return true;
      }

      var selectedDate;
      var error = false;
      var minDate = moment.tz(MIN_DATE, DATE_FORMAT, timezone);

      if (moment.isMoment(date)) {
        selectedDate = date;
      } else {
        // @ts-ignore
        selectedDate = moment.tz(date.target.value, DATE_FORMAT, timezone);
      }

      if (selectedDate.isBefore(minDate, 'day')) {
        error = true;
      }

      _this.setState({
        dateError: error
      });

      return error;
    };

    _this.changeDate = function (newDate) {
      //todo check if it could be event here
      var _a = _this.props,
          date = _a.date,
          timezone = _a.timezone,
          onChange = _a.onChange;
      var _b = _this.state,
          meridiem = _b.meridiem,
          hoursError = _b.hoursError,
          minutesError = _b.minutesError;
      var hasError = _this.checkDate(newDate) || hoursError || minutesError;

      if (!hasError) {
        var hours = parseInt(_this.state.hours, 10);
        var minutes = parseInt(_this.state.minutes, 10);

        if (typeof newDate !== 'object' || //@ts-ignore
        newDate.constructor !== date.constructor //todo: ?: newDate will always be Moment
        ) {
            newDate = date;
          }

        if (meridiem === 'pm') {
          hours += 12;
        }

        if (hours % 12 === 0) {
          hours -= 12;
        }

        newDate = moment.tz(newDate, timezone).hours(hours).minutes(minutes);
      }

      onChange(newDate, hasError);
    };

    _this.handleChangeHours = function (event) {
      event.preventDefault();
      var hours = parseInt(event.target.value, 10);

      _this.setState({
        hours: event.target.value,
        hoursError: isNaN(hours) || hours <= 0 || hours > MAX_HOURS
      });
    };

    _this.handleBlurHours = function () {
      var date = _this.props.date;
      var _a = _this.state,
          hours = _a.hours,
          hoursError = _a.hoursError;

      if (hoursError || hours === date.format('h')) {
        _this.setState({
          hours: date.format('hh'),
          hoursError: false
        });
      } else {
        _this.changeDate();
      }
    };

    _this.handleChangeMinutes = function (event) {
      event.preventDefault();
      var minutes = parseInt(event.target.value, 10);

      _this.setState({
        minutes: event.target.value,
        minutesError: isNaN(minutes) || minutes < 0 || minutes > MAX_MINUTES
      });
    };

    _this.handleBlurMinutes = function () {
      var date = _this.props.date;
      var _a = _this.state,
          minutes = _a.minutes,
          minutesError = _a.minutesError;

      if (minutesError || minutes === date.format('m')) {
        _this.setState({
          minutes: date.format('mm'),
          minutesError: false
        });
      } else {
        _this.changeDate();
      }
    };

    _this.handleChangeMeridiem = function (meridiemObject) {
      _this.setState({
        meridiem: meridiemObject.value
      }, _this.changeDate);
    };

    _this.state = tslib_1.__assign({}, _this.getInputValues(props.date), {
      dateError: false,
      hoursError: false,
      minutesError: false
    });
    return _this;
  }

  DateRow.prototype.componentWillReceiveProps = function (nextProps) {
    var date = this.props.date;

    if (!date.isSame(nextProps.date)) {
      this.setState(this.getInputValues(nextProps.date));
    }
  };

  DateRow.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        label = _a.label,
        timezone = _a.timezone,
        datePicker = _a.datePicker;
    var _b = this.state,
        hours = _b.hours,
        minutes = _b.minutes,
        meridiem = _b.meridiem,
        dateError = _b.dateError,
        hoursError = _b.hoursError,
        minutesError = _b.minutesError;
    var minDate = moment.tz(MIN_DATE, DATE_FORMAT, timezone);
    var date = this.props.date.tz(timezone);
    var maxDate = moment.tz(timezone);
    return React.createElement("div", {
      className: cx(className, 'drp-date-row')
    }, dateError && React.createElement("div", {
      className: "drp-date-row__error-message"
    }, "Nextiva Analytics only goes back to ", MIN_DATE), React.createElement("label", null, label), React.createElement(DatePicker, tslib_1.__assign({
      className: "drp-date-row__picker",
      dateFormat: DATE_FORMAT,
      selected: date,
      minDate: minDate,
      maxDate: maxDate,
      onChange: this.changeDate,
      customInput: React.createElement(TextField, null)
    }, datePicker)), React.createElement("span", {
      className: "drp-date-row__at"
    }, "at"), React.createElement(TextField, {
      className: cx('drp-date-row__hours', {
        'drp-date-row__error': hoursError
      }),
      min: "0",
      max: MAX_HOURS,
      value: hours,
      onChange: this.handleChangeHours,
      onBlur: this.handleBlurHours
    }), React.createElement("span", {
      className: "drp-date-row__colon"
    }, ":"), React.createElement(TextField, {
      className: cx('drp-date-row__minutes', {
        'drp-date-row__error': minutesError
      }),
      min: "0",
      max: MAX_MINUTES,
      value: minutes,
      onChange: this.handleChangeMinutes,
      onBlur: this.handleBlurMinutes
    }), React.createElement(Select, {
      className: "drp-date-row__meridiem",
      portalMenuWrapperClassName: "drp-date-row__meridiem--list",
      value: meridiem,
      onChange: this.handleChangeMeridiem,
      options: [{
        value: 'am',
        label: 'AM'
      }, {
        value: 'pm',
        label: 'PM'
      }]
    }));
  };

  return DateRow;
}(Component);

export default DateRow;